import { Address, erc20Abi } from "viem"

export default {
  abi: erc20Abi,
  address: "0x7b7C000000000000000000000000000000000000" as Address,
}
